// test2334
(2334 && 0);
